import { Component, ChangeDetectionStrategy } from '@angular/core';
import {UnsubscribeListService} from '../../../../../services/unsubscribe/unsubscribe-list.service';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {UnsubscribeProduct} from '../../../../../models/unsubscribe-product';
import {JsonPipe} from '@angular/common';
import {MetaTitle} from '../../../../../decorator/meta-title';

@Component({
  selector: 'app-unsubscribe-form',
  imports: [
    ReactiveFormsModule,
    JsonPipe
  ],
  templateUrl: './unsubscribe-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './unsubscribe-form.component.scss'
})
@MetaTitle('Opt-out')
export class UnsubscribeFormComponent {

  tab: 'overview' | 'lookup' | 'doc' = 'overview';
  products: UnsubscribeProduct[] | null = null;

  currentEmail!: string;
  form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  jsonBody = {
    success: true,
    message: null,
    data: [
      {
        id: 1,
        identifier: 'productid1'
      },
      {
        id: 2,
        identifier: 'productid2'
      }
    ]
  };

  constructor(private unsubscribeListService: UnsubscribeListService) {
  }

  submit(): void {
    this.currentEmail = this.form.value.email;

    this.unsubscribeListService.findByEmail(this.currentEmail).subscribe((products: UnsubscribeProduct[]) => {
      this.products = products;
    });
  }
}
